import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useConversationSearchBarStyles = makeStyles((theme: Theme) => ({
  searchBarWrapper: {
    padding: theme.spacing(1, 1.5),

    '& .xlrt-TextfieldInputWrapper': {
      minHeight: 'auto',
      padding: '.5rem .75rem',
      backgroundColor:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray20)'
          : 'rgba(217, 217, 217, 0.70)',
      borderRadius: '1000px',

      '& .v5-MuiInputAdornment-root': {
        marginRight: '.25rem',
        color:
          theme.palette?.mode === 'dark'
            ? 'var(--xlrt-color-ui-gray60)'
            : 'var(--xlrt-color-ui-gray40)',
      },

      '& .xlrt-TextfieldInput': {
        padding: '0',
        color:
          theme.palette?.mode === 'dark'
            ? 'var(--xlrt-color-ui-gray60)'
            : 'var(--xlrt-color-ui-gray40)',
      },
    },
  },
}));
